<style lang="less" scoped>
  @import "../../../style/theme.less";

  .ant-form-item {
    margin-bottom: 12px;
  }
</style>

<template>
  <a-modal :visible="!authenticated" title="Login" on-ok="handleOk">
    <template slot="footer">
      <a-button key="submit" type="primary" :loading="isLoading" @click="handleSubmit">
        Submit
      </a-button>
    </template>

    <a-alert v-if="error.show" :message="error.message" type="info" show-icon />

    <div class="spacer-lg" />

    <p>Please enter your username and password to sign in.</p>
    <a-form layout="vertical">
      <a-form-item>
        <a-input
          placeholder="Username"
          v-model="username"
        >
          <a-icon slot="prefix" type="user" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input
          type="password"
          placeholder="Password"
          v-model="password"
          @pressEnter="handleSubmit"
        >
          <a-icon slot="prefix" type="lock" />
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'admin.login',

  data: () => ({
    username: undefined,
    password: undefined,
  }),

  computed: {
    ...mapState('admin', ['error',]),
    ...mapGetters('admin', ['authenticated', 'isLoading',]),
  },

  methods: {
    ...mapActions('admin', ['login',]),

    handleSubmit() {
      return this.login({
        username: this.username,
        password: this.password,
      })
        .then(() => {
          this.password = undefined;
          if (!this.error.show) {
            this.$router.go({ name: 'admin.submissions', });
          }
        });
    },
  },
};
</script>
